import React from 'react'
import PropTypes from 'prop-types'
import styled from 'styled-components'
import {dialogButtonStyles} from '../dialog-button'
import {dialogStyles} from '../dialog'
import {dialogTitleStyles} from '../dialog-title'
import {dialogContentStyles} from '../dialog-content'
import {dialogActionsStyles} from '../dialog-actions'
import {createDialogQueue, DialogQueue as RmwcDialogQueue} from '@rmwc/dialog'
import '@rmwc/dialog/styles'

const StyledRmwcDialogQueue = styled(RmwcDialogQueue)`
  ${dialogStyles({selector: '&&&.mdc-dialog'})}
  &&&.mdc-dialog {
    ${dialogTitleStyles({selector: '.mdc-dialog__title'})}
    ${dialogContentStyles({selector: '.mdc-dialog__content'})}
    ${dialogActionsStyles({selector: '.mdc-dialog__actions'})}
    ${dialogButtonStyles({selector: '.mdc-dialog__button'})}
  }
`

const DialogQueue = ({children, ...otherProps}) => <StyledRmwcDialogQueue {...otherProps}>{children}</StyledRmwcDialogQueue>

DialogQueue.propTypes = {
  children: PropTypes.any
}

export {DialogQueue}
export {createDialogQueue}
